import * as Yup from 'yup';
import { fromUtcDay, createSortSchema, createPaginationSchema } from '@emfood/shared';

const BuyerOrdersListFilterSchema = Yup.object({
  distributorOrgId: Yup.string().optional(),
  distributorSiteId: Yup.string().optional(),
  buyerOrgId: Yup.string().optional(),
  buyerSiteId: Yup.string().optional(),

  // Search term
  searchTerm: Yup.string().trim().max(50).optional(),

  // Ordered on filter
  orderedOnFrom: Yup.string().optional().nullable(),
  orderedOnTo: Yup.string()
    .optional()
    .nullable()
    .test(
      'date-validation',
      'orderedOnTo must be on or after orderedOnFrom',
      function isAfterOrderedOnFrom(value) {
        // Normalise both sides to the picked calendar day before comparing: form values
        // can mix bare 'yyyy-MM-dd' (loaded from the URL) with freshly-picked ISO strings.
        const from = fromUtcDay(this.parent.orderedOnFrom);
        const to = fromUtcDay(value);
        if (!from || !to) return true;
        return to.getTime() >= from.getTime();
      }
    ),

  // Delivery date filters
  deliveryDateFrom: Yup.string().optional().nullable(),
  deliveryDateTo: Yup.string()
    .optional()
    .nullable()
    .test(
      'date-validation',
      'deliveryDateTo must be on or after deliveryDateFrom',
      function isAfterDeliveryDateFrom(value) {
        // Normalise both sides to the picked calendar day before comparing: form values
        // can mix bare 'yyyy-MM-dd' (loaded from the URL) with freshly-picked ISO strings.
        const from = fromUtcDay(this.parent.deliveryDateFrom);
        const to = fromUtcDay(value);
        if (!from || !to) return true;
        return to.getTime() >= from.getTime();
      }
    ),
});

// Pick date related filters for use with React Hook Form (we use RHF only on date related
// filters as these are the only ones needed validation)
export const DateFilterSchema = BuyerOrdersListFilterSchema.pick([
  'orderedOnFrom',
  'orderedOnTo',
  'deliveryDateFrom',
  'deliveryDateTo',
]);

export type DateFilterModel = Yup.InferType<typeof DateFilterSchema>;

export const BuyerOrdersListSearchParamsSchema = BuyerOrdersListFilterSchema.concat(
  createPaginationSchema()
).concat(
  createSortSchema(
    ['orderReferenceNumber', 'createdOn', 'deliveryDate', 'buyer', 'distributor'] as const,
    {
      defaultSortBy: 'createdOn',
      defaultSortOrder: 'desc',
    }
  )
);
